import { LeftOutlined } from "@ant-design/icons";
import "./MobileHeaderDropdown.scss";

export interface MobileProductDropdownProps {
  toggleProduct: (ev: React.MouseEvent) => void;
}

export default function MobileProductDropdown({ toggleProduct }: MobileProductDropdownProps) {
  return (
    <ul className={"drawer-nav"}>
      <li className="header" onClick={(ev) => toggleProduct(ev)}>
        <LeftOutlined />
        <span>Product</span>
      </li>

      <div className="label">
        Platform
      </div>
      <li>
        <a href="/feature/digital-menu-board-solution.html">
          <img src="https://timber.mhmcdn.com/site/marketing/icons/DSABlack.svg" alt="digital signage" />
          <span>Digital Signage</span>
        </a>
      </li>
      <li>
        <a href="/feature/easy-menu-design-for-restaurants.html">
          <img src="https://timber.mhmcdn.com/site/marketing/icons/PaintbrushIcon.svg" alt="menu designer" />
          <span>Menu Designer</span>
        </a>
      </li>
      <li>
        <a href="/feature/Print-Services.html">
          <img src="https://timber.mhmcdn.com/site/marketing/icons/FilterProducts/TableTent.svg" alt="print services" />
          <span>Print Products</span>
        </a>
      </li>
      <li>
        <a href="/feature/menu-qr-code.html">
          <img src="https://timber.mhmcdn.com/site/marketing/icons/QRCode.svg" alt="qr menus" />
          <span>QR Codes</span>
        </a>
      </li>
      <li>
        <a href="/feature/online-menu.html">
          <img src="https://timber.mhmcdn.com/site/marketing/icons/OnlineMenus.svg" alt="online menus" />
          <span>Online Menus</span>
        </a>
      </li>
      <li>
        <a href="/feature/restaurant-landing-pages.html">
          <img src="https://timber.mhmcdn.com/site/marketing/icons/MegaphoneFilled.svg" alt="link pages" />
          <span>Link Pages</span>
        </a>
      </li>

      <div className="label">
        Solutions
      </div>
      <li>
        <a href="/feature/menu-services.html">
          <img src="https://timber.mhmcdn.com/site/marketing/icons/CustomerService.svg" alt="menu services" />
          <span>Menu Services</span>
        </a>
      </li>
      <li>
        <a href="/feature/restaurant-menu-management.html">
          <img src="https://timber.mhmcdn.com/site/marketing/icons/MenuManagement.svg" alt="menu management" />
          <span>Menu Management</span>
        </a>
      </li>
      <li>
        <a href="/content/toast-partner-connect">
          <img src="https://timber.mhmcdn.com/site/marketing/icons/ToastGray.svg" alt="toast logo" />
          <span>Toast Integration</span>
        </a>
      </li>
      <li>
        <a href="/feature/square-pos.html">
          <img src="https://timber.mhmcdn.com/site/marketing/icons/SquareGray.svg" alt="square logo" />
          <span>Square Integration</span>
        </a>
      </li>

      <div className="label">
        Templates
      </div>
      <li>
        <a href="/menu/browse.do">
          <img src="https://timber.mhmcdn.com/site/marketing/icons/Templates.svg" alt="menu templates" />
          <span>Menu Templates</span>
        </a>
      </li>
      <li>
        <a href="/category/Digital-Menu-Boards.html">
          <img src="https://timber.mhmcdn.com/site/marketing/icons/DigiBoard.svg" alt="digital signage" />
          <span>Digital Signage</span>
        </a>
      </li>
      <li>
        <a href="/category/takeout-menus.html">
          <img src="https://timber.mhmcdn.com/site/marketing/icons/FilterProducts/Takeout.svg" alt="takeout templates" />
          <span>Takeout Templates</span>
        </a>
      </li>
      <li>
        <a href="/category/half-page-menus.html">
          <img src="https://timber.mhmcdn.com/site/marketing/icons/FilterProducts/HalfPageMenu.svg" alt="half page templates" />
          <span>Half Page Templates</span>
        </a>
      </li>
      <li>
        <a href="/category/restaurant-flyer.html">
          <img src="https://timber.mhmcdn.com/site/marketing/icons/FilterProducts/Flyer.svg" alt="flyer templates" />
          <span>Flyer Templates</span>
        </a>
      </li>
      <li>
        <a href="/category/business-cards.html">
          <img src="https://timber.mhmcdn.com/site/marketing/icons/FilterProducts/BusinessCard.svg" alt="business card templates" />
          <span>Business Card Templates</span>
        </a>
      </li>
      <li>
        <a href="/category/table-tent.html">
          <img src="https://timber.mhmcdn.com/site/marketing/icons/FilterProducts/TableTent.svg" alt="table tent templates" />
          <span>Table Tent Templates</span>
        </a>
      </li>
      <li>
        <a href="/category/marketing-templates.html">
          <span>...and more</span>
        </a>
      </li>
    </ul>
  )
}